<template>
  <span>
    <ViewBar :hidden="true"></ViewBar>
    <v-tabs fixed-tabs slot="extension" v-model="selectedTab">
      <v-tab v-if="canSeeOverallStats" id="overallStatsForTour">
        {{ $t('app.label.dashboard') }}
      </v-tab>
      <v-tab-item v-if="canSeeOverallStats">
        <OverallMetrics></OverallMetrics>
      </v-tab-item>
      <v-tab v-if="canSeeCorpusStats" id="corpusStatsForTour">
        {{ $t('dataset.corpus.corpus') }}
      </v-tab>
      <v-tab-item v-if="canSeeCorpusStats">
        <CorpusMetrics :statistics="stats"></CorpusMetrics>
      </v-tab-item>
      <v-tab v-if="canSeeDatasetStats && this.project.nature !== 'question_answering'" id="datasetStatsForTour">
        {{ $t('app.label.dataset') }}
      </v-tab>
      <v-tab-item v-if="canSeeDatasetStats">
        <DatasetMetrics :statistics="stats"></DatasetMetrics>
      </v-tab-item>
<!--      <v-tab v-if="canSeeModelStats && this.project.nature !== 'question_answering'" id="modelStatsForTour">-->
<!--        {{ $t('dataset.model.model') }}-->
<!--      </v-tab>-->
<!--      <v-tab-item v-if="canSeeModelStats">-->
<!--        <ModelMetrics :statistics="stats"></ModelMetrics>-->
<!--      </v-tab-item>-->
    </v-tabs>
  </span>
</template>

<script>
import DatasetMetrics from "../components/dashboard/DatasetMetrics";
import CorpusMetrics from "../components/dashboard/CorpusMetrics";
// import ModelMetrics from "../components/dashboard/ModelMetrics";
import OverallMetrics from "../components/dashboard/OverallMetrics";
import ViewBar from "../components/viewbar/ViewBar";
import tourMixin from "../tourUtils/tourMixin";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    DatasetMetrics,
    CorpusMetrics,
    // ModelMetrics,
    OverallMetrics,
    ViewBar,
  },
  data() {
    return {
      selectedTab: "Corpus"
    }
  },
  created: function () {
    tourMixin.enhance(this, "tourNext");
  },
  mounted() {
    this.fetchLabels().then(this.getStats).then(this.tourNext)
    // this.tourNext();
  },
  updated() {
    this.fetchLabels().then(this.getStats)
  },
  computed: {
    ...mapState("dataset", [
      "stats",
    ]),
    ...mapState(["project"]),
    ...mapGetters("auth", ["canSeeDatasetStats", "canSeeCorpusStats", "canSeeModelStats", "canSeeOverallStats"])
  },
  methods: {
    ...mapActions("settings", [
      "fetchLabels",
    ]),
    ...mapActions("dataset", [
      "getStats",
    ]),
  }
};
</script>
